import templateUrl from "./reset-password.html";

import find from "lodash/find";

export const resetPasswordComponent = {
  bindings: {
    token: "<",
  },

  templateUrl,

  controller: class PasswordComponent {
    constructor(AuthService, ApiService, toastr, $state) {
      "ngInject";

      this.authService = AuthService;
      this.apiService = ApiService;
      this.toastr = toastr;
      this.$state = $state;
    }

    $onInit() {
      this.passwordType = "password";
      this.showResetForm = true;
      this.showThankingMsg = false;
    }

    onShowPasswordChange() {
      this.passwordType = this.showPassword ? "text" : "password";
    }

    confirmReset() {
      this.showResetForm = true;
      this.showConfirmReset = false;
    }

    resetPassword() {
      if (this.details.newPassword !== this.details.confirmPassword) {
        this.mismatchPswd = true;
      } else {
        this.authService
          .resetPassword(this.token, this.details)
          .then((details) => {
            this.showResetForm = false;
            this.showThankingMsg = true;
          })
          .catch((error) => {
            this.toastr.error(error);
          });
      }
    }
    goBack() {
      this.$state.go("login");
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/auth/reset-password/reset-password.component.js